import { Box, VStack } from "@chakra-ui/react";
import ApiKey from "./apiKey";
import SandboxToggle from "./sandbox";
import Webhook from "./webhook";
import { useAppContext } from "../contexts/app";

export default function Settings() {
  const { state } = useAppContext();

  if (state.isLoaded) {
    return (
      <Box>
        <VStack p={10} align="stretch">
          <ApiKey />
          <Webhook />
          <SandboxToggle />
        </VStack>
      </Box>
    );
  }

  return null;
}
